import script from "./ArtefactDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtefactDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./ArtefactDashboard.vue?vue&type=style&index=0&id=34870ef5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34870ef5"]])

export default __exports__